import {Component, ElementRef, input, signal, viewChild, ChangeDetectionStrategy} from "@angular/core"
import {NgClass} from "@angular/common"
import {TestCaseEntry} from "@app/test/manual-testing/helpers/configurator-test-helpers"
import {TestButtonComponent} from "@app/test/manual-testing/test-button/test-button.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-test-container",
    templateUrl: "./test-container.component.html",
    styleUrls: ["./test-container.component.scss"],
    imports: [NgClass, TestButtonComponent],
})
export class TestContainerComponent {
    readonly $testCases = input.required<TestCaseEntry[]>({alias: "testCases"})

    private readonly $image = viewChild.required<ElementRef<HTMLImageElement>>("image")
    readonly $showOverlay = signal(false)

    setImage(src: string) {
        this.$image().nativeElement.src = src
        this.$showOverlay.set(true)
    }
}
